export const messages = {
  a11yFilters: 'Filters',

  filters: 'Filters',
  show: 'show',
  resetAll: 'Reset All',
};
